import React, { useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
export function YtMartesFooter() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <footer className="w-full bg-gray-900 border-t border-gray-800 py-6 mt-auto" data-id="element-1051">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-1052">
          {/* Additional Legal Disclaimer for YouTube Compliance */}
          <div className="mb-6 pb-6 border-b border-gray-800" data-id="element-1053">
            <p className="text-xs md:text-sm text-gray-400 leading-relaxed" data-id="element-1054">
              <span className="font-semibold text-gray-300" data-id="element-1055">Aviso Legal:</span>{' '}
              Este producto o servicio utiliza tecnología avanzada para asistir
              en tareas digitales. No garantizamos resultados específicos, ya
              que el rendimiento puede variar según el uso individual. Los
              testimonios presentados son experiencias de usuarios reales, pero
              no implican una promesa de éxito. Es importante utilizar esta
              herramienta de manera responsable y ética. Este sitio no está
              afiliado ni respaldado por Google LLC ni YouTube.
            </p>
          </div>

          <div className="flex flex-col items-center gap-6 mb-6" data-id="element-1056">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nsoAdMCr2MakXFCqq5bSP/gb_signature.png" alt="Signature" className="w-full max-w-[150px]" data-id="element-1057" />
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1058">
            <div className="text-gray-400 text-sm" data-id="element-1059">
              © 2024 TrueMarketer. Todos los derechos reservados.
            </div>
            <div className="flex items-center gap-6 text-sm" data-id="element-1060">
              <button onClick={() => setIsModalOpen(true)} className="text-gray-400 hover:text-white transition-colors" data-id="element-1061">
                Política de Privacidad
              </button>
              <a href="mailto:support@truemarketer.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-1062">
                support@truemarketer.com
              </a>
            </div>
          </div>
        </div>
      </footer>
      <PrivacyPolicyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-1063" />
    </>;
}